
define('logging',[], function () {
    var _LoggingEnabled = false;
    var _defaultSiteName = "Patheos";

    function init(enabled) {
        _LoggingEnabled = enabled;

        if (typeof console == "undefined" || !console) {
            console = {};
            console.log = function (obj) { }
        }
        if (typeof console.debug == "undefined" || !console.debug) {
            console.warn = console.log;
        }
        if (typeof console.warn == "undefined" || !console.warn) {
            console.warn = console.log;
        }
        if (typeof console.debug == "undefined" || !console.debug) {
            console.debug = console.log;
        }
    }

    function log(str, module) {
        if (_LoggingEnabled) {
            var name = (typeof module == "string") ? module : _defaultSiteName;
            console.log("%c %c " + name + " Log: %c " + str, "background: blue; color: #fff;", "background: green; color: #fff;", "");
        }
    }

    function debug(str, module) {
        if (_LoggingEnabled) {
            var name = (typeof module == "string") ? module : _defaultSiteName;
            console.debug("%c %c " + name + " Debug: %c " + str, "background: orange; color: #fff;", "background: blue; color: #fff;", "");
        }
    }

    function warn(str, module) {
        if (_LoggingEnabled) {
            var name = (typeof module == "string") ? module : _defaultSiteName;
            console.warn(name + " Warning: " + str);
        }
    }

    function error(str, module) {
        if (_LoggingEnabled) {
            var name = (typeof module == "string") ? module : _defaultSiteName;
            console.error(name + " Error: " + str);
        }
    }

    return {
        init: init,
        log: log,
        debug: debug,
        warn: warn,
        error: error
    }
});
